<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Add currency</h4>
      </div>
      <div class="modal-body">
        <div class="form-group mb-3">
          <label>Currency Type</label>
          <select class="form-control" [(ngModel)]="currencyType">
            @for (key of $any(UserCurrencyType) | keyvalue; track key.key) {
              @if (!isNaN(+key.value)) {
                <option [ngValue]="+key.value">{{ key.key }}</option>
              }
            }
          </select>
        </div>
        <div class="form-group mb-3">
          <label>Quantity</label>
          <input class="form-control" [(ngModel)]="currencyQuantity" placeholder="0" type="number">
        </div>
        <div class="form-group">
          <label>Ticket Cost</label>
          <input class="form-control" [(ngModel)]="currencyTicketCost" placeholder="0" type="number">
        </div>
      </div>
      <div class="modal-footer">
        <button [disabled]="isLoading" type="button" class="btn btn-secondary" (click)="modal.hide()">Cancel</button>
        <button [disabled]="isLoading" type="button" class="btn btn-primary" (click)="save()">
          <span *ngIf="isLoading" class="spinner-border spinner-border-sm mr-1"></span>
          Add
        </button>
      </div>
    </div>
  </div>
</div>
